import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '../models/user';
import { AuthService } from '../services/authService';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { MealResponse, MealViewModel } from '../models/mealResponseModel';

@Component({
    selector: 'app-meal',
    templateUrl: './meal.component.html',
    styleUrl: './meal.component.scss',
    standalone: false
})

export class MealComponent {
  user = new User('', false);
  http!: HttpClient;
  response?: any;
  @Input() mealType: string = '';
  @Input() mealTypeIdChange!: EventEmitter<number>;
  @Output() mealChange = new EventEmitter<MealViewModel[]>();
  mealViewModels: MealViewModel[] = [];
  mealTypeId: number = 0;
  private mealsSubject = new BehaviorSubject<MealViewModel[]>([]);
  meals$ = this.mealsSubject.asObservable();
  errorMessages: string[] = [];

  constructor(private authService: AuthService, http: HttpClient) {
    this.http = http;
  }

  public async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();

    if (isLoggedIn) {
      this.setMealTypeId();
      this.getMealsForCurrentUser(this.mealTypeId);
    }

    // Subscribe to the mealTypeIdChange event
    if (this.mealTypeIdChange) {
      this.mealTypeIdChange.subscribe((newMealTypeId: number) => {
        this.onMealTypeIdChange(newMealTypeId);
      });
    }
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private async getMealsForCurrentUser(mealTypeId: number): Promise<MealViewModel[]> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return new Promise<MealViewModel[]>((resolve, reject) => {
      this.http.get<MealResponse>('/api/UserMeals/get_meals_for_current_user', {
        headers: headers,
        params: {
          mealTypeId: mealTypeId,
        },
      }).pipe(catchError(this.handleError<MealResponse>('getMealsForCurrentUser')))
        .subscribe({
          next: (result) => {
            if (result.success === true) {
              // Success
              this.mealsSubject.next(result.mealViewModels);
              resolve(result.mealViewModels);
              if (result.mealViewModels.length > 0) {
                this.mealViewModels = result.mealViewModels;
              } else {
                // send a mealViewModel with one element indicating that there are no meals
                this.mealViewModels = [{ mealId: 0, mealTypeId: mealTypeId, foodName: 'No meals found', quantity: 0, unitOfMeasure: "", alcohol: 0, calories: 0, protein: 0, netcarbs: 0, fat: 0 }];
              }


              this.mealChange.emit(this.mealViewModels);
            } else {
              if (result.errorMessages) {
                // Sad
                this.errorMessages = result.errorMessages;
                window.alert(
                  'We have have one or more errors. Check the console logs.'
                );
                for (const errorMessage of result.errorMessages) {
                  console.error(errorMessage);
                }
              }
              resolve([]);
            }
          },
          error: (error) => {
            console.error(error);
            reject(error);
          },
        });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private setMealTypeId() {
    switch (this.mealType.toLocaleLowerCase().trim()) {
      case 'breakfast':
        this.mealTypeId = 1;
        break;
      case 'lunch':
        this.mealTypeId = 2;
        break;
      case 'dinner':
        this.mealTypeId = 3;
        break;
      case 'snacks':
        this.mealTypeId = 4;
        break;
    }
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private onMealTypeIdChange(newMealTypeId: number) {
    this.getMealsForCurrentUser(newMealTypeId);
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  public deleteMeal(mealId: number): void {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    const params = new HttpParams().set('id', mealId.toString()); // Correctly set the query parameter

    this.http.delete<any>('/api/UserMeals/delete_meal', {
      headers: headers,
      params: params,
    }).pipe(catchError(this.handleError<any>('deleteMeal')))
      .subscribe({
        next: (result) => {
          if (result.success === true) {
            this.getMealsForCurrentUser(this.mealTypeId);
          } else {
            if (result.errorMessages) {
              this.errorMessages = result.errorMessages;
              for (const errorMessage of result.errorMessages) {
                console.error(errorMessage);
              }
            }
          }
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
}
